export const StatusBadge = ({ isActive, compact = false }) => {
  const badgeStyle = {
    padding: compact ? "2px 8px" : "4px 12px",
    borderRadius: "4px",
    display: "inline-block",
    fontSize: compact ? "12px" : undefined,
    lineHeight: compact ? 1.3 : undefined,
    whiteSpace: "nowrap",
  };

  return isActive ? (
    <span
      style={{
        ...badgeStyle,
        color: "#198754",
        backgroundColor: "#d1e7dd",
      }}
    >
      Active
    </span>
  ) : (
    <span
      style={{
        ...badgeStyle,
        color: "#dc3545",
        backgroundColor: "#f8d7da",
      }}
    >
      Inactive
    </span>
  );
};

export const formatRfidDate = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatRfidDateTime = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const HISTORY_STATUS_STYLES = {
  active: { color: "#198754", backgroundColor: "#d1e7dd" },
  inactive: { color: "#dc3545", backgroundColor: "#f8d7da" },
  created: { color: "#0d6efd", backgroundColor: "#cfe2ff" },
  updated: { color: "#664d03", backgroundColor: "#fff3cd" },
  default: { color: "#374151", backgroundColor: "#E5E7EB" },
};

const getHistoryStatusStyle = (statusName = "") => {
  const normalized = statusName.toLowerCase();

  if (normalized.includes("inactive")) return HISTORY_STATUS_STYLES.inactive;
  if (normalized.includes("active")) return HISTORY_STATUS_STYLES.active;
  if (normalized.includes("created")) return HISTORY_STATUS_STYLES.created;
  if (normalized.includes("updated") || normalized.includes("modified")) {
    return HISTORY_STATUS_STYLES.updated;
  }

  return HISTORY_STATUS_STYLES.default;
};

export const HistoryStatusBadge = ({ statusName, compact = false }) => {
  const label = statusName || "N/A";
  const style = getHistoryStatusStyle(label);

  return (
    <span
      style={{
        ...style,
        padding: compact ? "2px 8px" : "4px 12px",
        borderRadius: "4px",
        display: "inline-block",
        fontSize: compact ? "12px" : undefined,
        lineHeight: compact ? 1.3 : undefined,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
};
